// Content that is the same in every language. Translated text lives in
// en.js, th.js and zh.js, keyed by the ids used here.

export const person = {
  firstName: 'Agathit',
  lastName: 'Domrongwatanagoon',
  email: 'agathit.domrongwatanagoon@gmail.com',
  phone: '096-146-5952',
  phoneHref: 'tel:0961465952',
  links: {
    github: 'https://github.com/nxg01542',
    linkedin: 'https://www.linkedin.com/in/agathit-domrongwatanagoon-b032b726b/',
    facebook: 'https://www.facebook.com/profile.php?id=100004195891082',
  },
};

export const languages = [
  { code: 'en', label: 'EN' },
  { code: 'th', label: 'ไทย' },
  { code: 'zh', label: '中文' },
];

export const projectFilters = ['all', 'web', 'ai'];

// Display order, strongest first.
export const projects = [
  {
    id: 'mesa',
    domains: ['ai'],
    stack: ['Image Processing', 'Python', 'OpenCV', 'C#', 'Desktop App Development'],
  },
  {
    id: 'project-quotation',
    domains: ['web'],
    stack: ['React', 'MUI', 'TanStack Query', 'Node.js', 'Express.js', 'Prisma', 'PostgreSQL', 'Puppeteer'],
  },
  {
    id: 'findback',
    domains: ['web'],
    stack: [],
    url: 'https://findbacktech.com',
    urlLabel: 'findbacktech.com',
  },
  {
    id: 'self-hosted-platform',
    domains: ['web'],
    stack: ['Ubuntu Server', 'Docker Compose', 'Nginx', 'Cloudflare', 'WireGuard', 'PostgreSQL'],
  },
  {
    id: 'central',
    domains: ['web'],
    stack: ['React', 'Express.js', 'MSSQL', 'REST API', 'JavaScript'],
  },
  {
    id: 'lot-status',
    domains: ['web'],
    stack: ['Angular', 'C#/.NET', 'MSSQL', 'Kibana', 'Elasticsearch', 'Docker'],
  },
  {
    id: 'predictive-maintenance',
    domains: ['ai'],
    stack: ['Python', 'Machine Learning', 'scikit-learn', 'Data Analysis'],
  },
  {
    id: 'glass-production-tracking',
    domains: ['web'],
    stack: ['React', 'Socket.IO', 'Node.js', 'Express.js', 'Prisma', 'PostgreSQL'],
  },
  {
    id: 'pricing-calculator',
    domains: ['web'],
    stack: ['React', 'MUI', 'Node.js', 'Express.js', 'Prisma', 'PostgreSQL'],
  },
  {
    id: 'line-ordering',
    domains: ['web'],
    stack: ['LINE API', 'JavaScript', 'Web Development', 'API Integration'],
  },
  {
    id: 'fpga-rl',
    domains: ['ai'],
    stack: ['VHDL', 'Reinforcement Learning', 'FPGA', 'Digital Circuits', 'OpenAI Gym'],
  },
];

export const skillGroups = [
  { id: 'frontend', skills: ['React', 'Angular', 'JavaScript', 'TypeScript', 'MUI', 'TanStack Query'] },
  { id: 'backend', skills: ['Node.js', 'Express.js', 'Prisma', 'Socket.IO', 'C#/.NET', 'REST API'] },
  { id: 'data', skills: ['SQL', 'PostgreSQL', 'MSSQL', 'ELK Stack', 'Grafana'] },
  { id: 'infrastructure', skills: ['Docker', 'Docker Compose', 'Nginx', 'Cloudflare', 'WireGuard', 'Ubuntu Server'] },
  { id: 'ai', skills: ['Python', 'Machine learning', 'scikit-learn', 'OpenCV'] },
  { id: 'hardware', skills: ['VHDL', 'FPGA', 'C/C++'] },
  { id: 'markets', skills: ['MQL5', 'MetaTrader 5'] },
];
